import Joi from 'joi'
import {emailValidation, inputPhoneValidation, inputStringValidation, textAreaValidation} from 'validation'

export const statusPageSchema = Joi.object({
  name: inputStringValidation.required().min(3).max(50),
  description: textAreaValidation.allow('', null).max(150),
})

export const incidentsSchema = Joi.object({
  title: Joi.string().trim().max(30).required().label('Title'),
  description: Joi.string().trim().max(100).allow('').optional().label('Description'),
  sourceId: Joi.number().required(),
  currentStatus: Joi.array()
    .items(
      Joi.object().keys({
        currentStatusDesc: Joi.string().trim().max(200).required().messages({
          'string.empty': 'Status Description is required',
          'string.max': 'Status Description length must be less than or equal to 200 characters long',
        }),
        currentStatusId: Joi.number().required().messages({
          'number.base': 'Status is required',
        }),
        currentStatusTime: Joi.date().allow(''),
      })
    )
    .optional(),
  notifySubscribers: Joi.boolean(),
  isBackFill: Joi.boolean(),
  startDate: Joi.date().allow(''),
  endDate: Joi.alternatives().conditional('isBackFill', {
    is: true,
    then: Joi.date().timestamp().min(Joi.ref('startDate')).required().messages({
      'date.min': `End Time must be greater than Start Time`,
    }),
    otherwise: Joi.date().allow(''),
  }),
})

export const maintainanceSchema = Joi.object({
  title: Joi.string().trim().max(30).required().label('Title'),
  description: Joi.string().trim().max(500).allow('').optional().label('Description'),
  sourceId: Joi.number().required().messages({
    'number.base': 'Source is required',
  }),
  notifySubscribers: Joi.boolean(),
  isBackFill: Joi.boolean(),
  startDate: Joi.date().allow(''),
  endDate: Joi.date().timestamp().min(Joi.ref('startDate')).required().messages({
    'date.min': `End Time must be greater than Start Time`,
  }),
  startAtSchedule: Joi.boolean(),
  endAtSchedule: Joi.boolean(),
  advanceOneDay: Joi.boolean(),
  advanceOneHour: Joi.boolean(),
  atStart: Joi.boolean(),
  onCompletion: Joi.boolean(),
})

export const serviceComponentsSchema = type => {
  if (type === 'group') {
    return Joi.object({
      name: Joi.string().trim().max(30).required().label('Name'),
      description: Joi.string().trim().max(200).required().label('Description'),
      startDate: Joi.allow(),
    })
  }
  return Joi.object({
    name: Joi.string().trim().max(30).required().label('Name'),
    description: Joi.string().trim().max(200).required().label('Description'),
    showHistory: Joi.boolean(),
    startDate: Joi.date().allow(''),
  })
}

export const customizationSchema = Joi.object({
  pageTitle: Joi.string().trim().min(3).max(30).required(),
  description: Joi.string().trim().min(5).max(100).required(),
  companyUrl: Joi.string().trim().max(40).allow(null, '').label('company url'),
  supportUrl: Joi.string().trim().uri().allow(null, '').label('support url'),
  reportUrl: Joi.string().trim().uri().allow(null, '').label('report url'),
  supportContact: inputPhoneValidation.allow(null, ''),
  copyRightText: Joi.string().trim().max(40).allow(null, ''),
  twitterLink: Joi.string().trim().max(60).allow(null, ''),
  linkedInLink: Joi.string().trim().max(60).allow(null, ''),
  fbLink: Joi.string().trim().max(60).allow(null, ''),
  youtubeLink: Joi.string().trim().max(60).allow(null, ''),
  instaLink: Joi.string().trim().max(60).allow(null, ''),
  footerLink: Joi.string().trim().uri().allow(null, ''),
  seoPageMessage: Joi.string().trim().max(60).allow(null, '').label('Message'),
  seoTitle: Joi.string().trim().max(40).allow(null, '').label('Title'),
  seoDescription: Joi.string().trim().max(100).allow(null, '').label('Description'),
  // seoKeywords: Joi.string().trim(),
  domain: Joi.allow(null),
  statusOverview: Joi.boolean(),
  systemMatrix: Joi.boolean(),
  themeView: Joi.string().required(),
})

export const subscriberSchema = Joi.object({
  email: emailValidation.required().label('Email'),
  sendNotification: Joi.boolean(),
})

export const generalSettingsSchema = Joi.object({
  cname: Joi.string().required(),
})

export const templatesSchema = Joi.object({
  type: Joi.string().required(),
  title: Joi.string().trim().max(30).required().label('title'),
  description: Joi.string().trim().max(100).required().label('description'),
  sourceId: Joi.number().required().label('source').messages({
    'any.required': `source is a required field`,
    'number.base': `source is a required field`,
  }),
  notifySubscribers: Joi.boolean(),
})

export const incidentSourceSchema = Joi.object({
  source: Joi.string().trim().max(30).required().label('Source').messages({
    'string.max': 'length must be maximum 30 characters or less',
  }),
})

export const incidentStatusSchema = Joi.object({
  status: Joi.string().trim().max(30).required().label('Status').messages({
    'string.max': 'length must be maximum 30 characters or less',
  }),
  color: Joi.string().trim().required(),
})
